@if (canRecord()) {

	<button type="button" class="action-button accent-alt"
			[class.loading]="isRecording() || isTranscribing()"
			[disabled]="disabled || isTranscribing()"
			(click)="toggleVoiceRecording()">

		@if (isRecording()) {
			<mat-icon svgIcon="chat-square" aria-hidden="true"></mat-icon>
		} @else if (isTranscribing()) {
			<mat-icon svgIcon="microphone" aria-hidden="true"></mat-icon>
		} @else {
			<mat-icon svgIcon="microphone" aria-hidden="true"></mat-icon>
		}
	</button>


}

